import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { SYMBOL_HYPHEN } from '../../../../../../constants/common'
import Button, { BUTTON_HEIGHT_24 } from '../../../../../Button'
import { ICON_HEIGHT_24 } from '../../../../../Icon'
import Text from '../../../../../Text'
import {
  getIsMatchCriterionNotApplicable,
  getMatchCriterionLabelKey,
  getMatchCriterionStatusText,
  getMatchCriterionValueText,
  RentalPortalMatchCriterionChip,
  RentalPortalMatchProvenanceDot,
} from '../../../../RentalPortalMatch'
import {
  ApplicantFitCheckBlockRowEditor,
  getHasMatchEditor,
} from '../ApplicantFitCheckBlockRowEditor'
import { ApplicantFitCheckBlockSuggestion } from '../ApplicantFitCheckBlockSuggestion'

import * as styles from './ApplicantFitCheckBlockRow.module.css'

import EditIcon from '../../../../../../icons/edit.svg'

function ApplicantFitCheckBlockRow({
  criterion,
  currency,
  editValue,
  isEditing,
  isReadOnly,
  isSaving,
  isSubmitting,
  suggestion,
  onAcceptSuggestion,
  onCancelEdit,
  onChangeEditValue,
  onDismissSuggestion,
  onSaveEdit,
  onStartEdit,
}) {
  const { t } = useTranslation()

  const mutedClassName = getIsMatchCriterionNotApplicable(criterion)
    ? styles.muted
    : null

  return (
    <>
      <Text className={classNames(styles.label, mutedClassName)}>
        {t(getMatchCriterionLabelKey(criterion.key))}
      </Text>
      <Text isSecondary className={classNames(styles.value, mutedClassName)}>
        {getMatchCriterionValueText({
          criterion,
          currency,
          isRequirement: true,
          t,
          value: criterion.listing_value,
        }) ?? SYMBOL_HYPHEN}
      </Text>
      <span className={classNames(styles.applicantValue, mutedClassName)}>
        {isEditing ? (
          <ApplicantFitCheckBlockRowEditor
            criterion={criterion}
            isSaving={isSaving}
            value={editValue}
            onCancel={onCancelEdit}
            onChange={onChangeEditValue}
            onSave={onSaveEdit}
          />
        ) : (
          <>
            {suggestion && !isReadOnly ? (
              <ApplicantFitCheckBlockSuggestion
                criterion={criterion}
                currency={currency}
                isSubmitting={isSubmitting}
                suggestion={suggestion}
                onAccept={onAcceptSuggestion}
                onDismiss={onDismissSuggestion}
              />
            ) : (
              <span className={styles.applicantValue}>
                <RentalPortalMatchProvenanceDot
                  provenance={criterion.provenance}
                />
                <Text isSecondary className={styles.value}>
                  {getMatchCriterionValueText({
                    criterion,
                    currency,
                    t,
                    value: criterion.applicant_value,
                  }) ?? SYMBOL_HYPHEN}
                </Text>
              </span>
            )}
            {!isReadOnly && getHasMatchEditor(criterion) ? (
              <Button.Text
                isGrey
                beforeIconProps={{ Icon: EditIcon, height: ICON_HEIGHT_24 }}
                className={styles.edit}
                height={BUTTON_HEIGHT_24}
                tooltip={t('RentalPortal.MatchEditKey')}
                onClick={onStartEdit}
              />
            ) : null}
          </>
        )}
      </span>
      <span className={classNames(styles.chip, mutedClassName)}>
        <RentalPortalMatchCriterionChip
          criterion={criterion}
          text={getMatchCriterionStatusText({ criterion, t })}
        />
      </span>
    </>
  )
}

export default ApplicantFitCheckBlockRow
